const commonConfig = {
  retry: 0,
  refetchOnWindowFocus: false,
};

export default commonConfig;
